import StateMixin from './StateMixin'
import Percentage from '@/components/report/content/Percentage'
import { viewportScale } from '@/lib/funcs'

export default {
  mixins: [ StateMixin ],
  props: {
    data: { type: Object, required: true },
    bg: String,
    indOverride: { default () { return null } }
  },

  data () { return { active: false } },

  methods: {
    vwScale ( px ) { return viewportScale( px ) },

    toggleInd () { this.$emit( 'toggle-ind' ) }
  },
  components: {
    Percentage
  }
}



// WEBPACK FOOTER //
// ./src/components/report/mixins/ContentMixin.js